<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="mb-lg">
            <div class="card" v-if="!isLoading">
              <argon-alert v-if="showAlert" color="danger">
                <strong>Alerta!</strong> Es necesario seleccionar una imagen!
              </argon-alert>
              <argon-alert
                v-if="showSuccess"
                color="success"
                :dismissible="true"
              >
                <strong>Completado!</strong> Campos guardados correctamente!
              </argon-alert>
              <div class="card-header pb-0">
                <div class="d-flex align-items-center">
                  <h4 class="mb-0">Convenio</h4>
                </div>
              </div>
              <div class="card-body">
                <p class="text-uppercase text-sm">META</p>
                <hr class="horizontal dark" />
                <div class="row">
                  <div class="col-6">
                    <a v-if="agreementLocal !== undefined" :href="agreementLocal" target="_blank">
                      CONVENIO SELECCIONADO
                    </a>
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Convenio</label
                    >
                    <argon-input
                      type="file"
                      id="0"
                      name="Convenio"
                      @change-image="onFileChange($event)"
                      accept="application/pdf"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Nombre</label
                    >
                    <argon-input
                      v-model="agreement.title"
                      id="1"
                      name="Nombre"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                    />
                  </div>
                  <div class="col-md-12">
                    <label for="example-text-input" class="form-control-label"
                      >Descripción</label
                    >
                    <argon-textarea
                      v-model="agreement.description"
                      id="1"
                      name="Descripción"
                      @valid="absoluteValidation($event)"
                      :isRequired="true"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <argon-button
                      color="primary"
                      size="lg"
                      class="ms-auto"
                      @click-callback="finalValidation"
                      :fullWidth="true"
                      >Guardar</argon-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "agreement-card",
  props: {
    agreementID: { type: String, required: true },
  },
  data() {
    return {
      isLoading: true,
      showAlert: false,
      showSuccess: false,
      valid: Array(4).fill(true),
      agreementIDLocal: this.agreementID,
      agreementLocal: undefined,
      agreementLocalSave: undefined,
      agreement: {
        title: "",
        description: ""
      },
    };
  },
  components: { ArgonInput, ArgonButton, ArgonAlert, ArgonTextarea },
  created() {
    // console.log("AGREEMENT AGREEMENT AGREEMENT");
    // console.log(this.agreementIDLocal);
    if (this.agreementIDLocal !== "0") {
      this.plain
        .get(`/agreements/${this.agreementIDLocal}`)
        .then((response) => {
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.agreementLocal = response.data.file_url;
          this.agreementLocalSave = response.data.file_url;
          delete response.data.file_url;
          this.agreement = response.data;
          this.isLoading = false;
          // console.log("RESPONSE AGREEMENT");
          // console.log(this.agreement);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    } else {
      this.agreementIDLocal = undefined;
      this.isLoading = false;
    }
  },
  methods: {
    absoluteValidation(event) {
      this.showAlert = false;
      this.showSuccess = false;
      this.valid[event.inputIndex] = event.valid;
    },
    finalValidation() {
      if (this.valid.includes(false)) {
        this.showAlert = true;
        window.scrollTo(0, 0);
      } else {
        if (this.agreementIDLocal !== undefined) this.editAgreement();
        else {
          // console.log(this.agreementLocal);
          if (this.agreementLocal !== undefined) this.createAgreement();
          else {
            this.showAlert = true;
            window.scrollTo(0, 0);
          }
        }
      }
    },
    createAgreement() {
      // console.log("CREANDO AGREEMENT");
      // console.log(this.agreement);
      let formData = new FormData();

      Object.entries(this.agreement).forEach(([key, value]) => {
        formData.append(`agreement[${key}]`, value);
      });

      this.form
        .post("/agreements", formData)
        .then((response) => {
          // console.log("AGREEMENT creado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          this.agreementIDLocal = response.data.id; //SOLUCIONAR PROBLEMA DE ALERTAS AQUI ES CON LA NAVEGACION route y con una variable local
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.agreementLocal = response.data.file_url;
          this.agreementLocalSave = response.data.file_url;
          delete response.data.file_url;
          this.agreement = response.data;
          // console.log("CREATE");
          // console.log(this.agreement);
        })
        .catch((error) => {
          console.log("Error al crear AGREEMENTS", error);
        });
    },
    editAgreement() {
      // console.log("PREPARANDO PARA EDITAR");
      // console.log(this.agreement);
      let formData = new FormData();

      Object.entries(this.agreement).forEach(([key, value]) =>
        formData.append(`agreement[${key}]`, value)
      );
      this.form
        .patch(`/agreements/${this.agreementIDLocal}`, formData)
        .then((response) => {
          // console.log("AGREEMENT editado correctamente");
          // console.log(response.data);
          window.scrollTo(0, 0);
          this.showSuccess = true;
          delete response.data.id;
          delete response.data.created_at;
          delete response.data.updated_at;
          this.agreementLocal = response.data.file_url;
          this.agreementLocalSave = response.data.file_url;
          delete response.data.file_url;
          this.agreement = response.data;
          // console.log("EDIT");
          // console.log(this.agreement);
        })
        .catch((error) => {
          console.log("Error al editar AGREEMENTS", error);
        });
    },
    onFileChange(file) {
      // console.log("FILE");
      // console.log(file);
      if (file !== undefined) {
        this.agreementLocal = URL.createObjectURL(file);
        this.agreement.file = file;
        this.showAlert = false;
        // console.log("ON FILE CHANGE");
        // console.log(this.agreement);
      } else {
        if (Object.keys(this.agreement).includes("image"))
          delete this.agreement.file;

        this.agreementLocal = this.agreementLocalSave;
      }
    },
  },
};
</script>